// extracted by mini-css-extract-plugin
export default {"sampleText":"SiteModal_sampleText_UMoJI","tooltip":"SiteModal_tooltip_Ij4fs","spinAround":"SiteModal_spinAround_TNQut"};